import { SurveyListModel } from "./searchSurvey.model";

export class SearchState {
    public isLoading: number =-1;
    public searchText: string = '';
    public survey: SurveyListModel[] = [];
    public pageSize: number = 20;
    public totalRecords: number = 0;
    public pageNumber: number = 1
}
